var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"oidc-callback"}},[_c('div',{staticClass:"ui medium active text loader"},[_vm._v("Logger ind...")])])}]

export { render, staticRenderFns }